'use strict';

var util = require('../components/util');

var _currencySymbol;

var initGiftCardMessage = function() {

	// init left character count and max characters
	var $mcl = $(".gc-message span.max-char-limit");
	var max = $mcl.data("maxlimit");
	var text = $mcl.html();
	$mcl.html( text.replace("XXX", "<span class=\"count\"></span>").replace("YYY", max) );
	var count = $(".gc-message textarea").val().length;
	var left = max - count;
	$(".gc-message span.count").text(left);

};

var checkBalance = function(giftCardNo, giftCardPin) {
	if (giftCardNo) {

		$.getJSON(Urls.checkBalance, {giftCardNo: giftCardNo, giftCardPin: giftCardPin, format: "ajax"
		}).done(function( data ) {
			if (data.giftCertificate) {
				$(".gc-no").html(data.giftCertificate.ID);
				$(".balance").html(data.giftCertificate.balance);

				$("input[name*=_giftCertPin]").data("pinrequired", "false");

				$("input[name*=_giftCertID]").val("");
				$("input[name*=_giftCertPin]").val("");
				$(".check-balance .gc-info").show();
			} else {
				if (data.error) {
					$(".check-balance .error").html(data.error).show();
				}
			}
		});
	}
};

var initializeDOM = function() {

	_currencySymbol = $(".gc-purchase").data("currencysymbol");

	initGiftCardMessage();

	// select the correct amount button if editing otherwise pre-select the first value
	if ($("#dwfrm_giftcert_purchase_amount").val()) {
		var gca = $("#dwfrm_giftcert_purchase_amount").val();
		var _value = gca.replace(/[^\d]/g, "");
		if ($('.purchase-amount li[data-amount=' + _value +']').length > 0) {
			$('.purchase-amount li[data-amount=' + _value + ']').click();
		} else {
			$(".purchase-amount li[data-amount='other']").click();
			$('.purchase-amount-other input').val(gca);
		}
	} else {
		$('.amount-selection ul li').first().click();
	}

	// Format fields for better UI
	util.updateInputTypes($('input[name$="_recipientEmail"]'), 'email');
	util.updateInputTypes($('input[name$="_confirmRecipientEmail"]'), 'email');
	util.updateInputTypes($('input[name$="_giftcert_purchase_amount"]'), 'tel');
	util.updateInputTypes($('input[name$="_giftCertPin"]'), 'tel');

};

var initializeEvents = function() {

	// set hidden form and button
	$(".amount-selection ul li").on("click", function() {
		if ($(this).data('amount') == 'other') {
			$('.purchase-amount-other input').val(_currencySymbol + ' ');
			$('.purchase-amount-other input').focus();
			$('.purchase-amount-other').show();
		} else {
			var gca = $(this).data('amount');
			$('.purchase-amount-other').hide();
			$("#dwfrm_giftcert_purchase_amount").val(gca);
		}

		// Remove error if exists
		$(".error.choose-amount").remove();

		$(this).siblings().removeClass('selected');
		$(this).addClass('selected');
	});

	// other amounts
	$(".purchase-amount-other .gift-cert-amount").on("keyup", function() {
		var gcao = $(this).val();
		var _prefixLen = (_currencySymbol + ' ').length;

		if (gcao.length < _prefixLen) {
			$(this).val(_currencySymbol + ' ');
			$(this).focus();
			return false;
		} else {
			return true;
		}
	});

	$("#GiftCertificateForm").on("click", ".purchase-amount-other .gift-cert-amount", function() {
		$(this).focus();
		var _this = this;
		setTimeout( function() {
			var _tmpStr = $(_this).val();
			$(_this).val('');
			$(_this).val(_tmpStr);
		}, 500);
	});

	$("#GiftCertificateForm input[name*=_from], #GiftCertificateForm input[name*=_recipient], #GiftCertificateForm input[name*=_recipientEmail], #GiftCertificateForm input[name*=_confirmRecipientEmail]").on("focusout", function() {
		if ($(this).val() != "") {
			$(this).removeClass("error");
			$(this).parent().find("span.error").hide();
		}
	});

	$("button.gc-balance-submit").on("click", function(e) {
		e.preventDefault();

		// Clear previous errors and any pre-existing data if any
		$(".check-balance .gc-info").hide();
		$(".check-balance .error").html("").hide();

		var _giftCardNo = $("input[name*=_giftCertID]").val();
		var _giftCardPin = $("input[name*=_giftCertPin]").val();

		// Always show the PIN field (if not already visible)
		$(".gc-balance-pin").show();

		// Validate gift card number and PIN
		if (_giftCardNo && /^[a-zA-Z0-9]+$/.test(_giftCardNo)) {
			if (_giftCardPin && _giftCardPin.length === 4 && /^[a-zA-Z0-9]+$/.test(_giftCardPin)) {
				// Both gift card number and PIN are valid
				checkBalance(_giftCardNo, _giftCardPin);
			} else {
				// Invalid or missing PIN
				$(".check-balance .error").html(Resources.VALIDATE_ERRORPREFIX + " " + Resources.GIFTCERT_BOTH_NO_BLANK).show();
			}
		} else {
			// Invalid or missing gift card number
			$(".check-balance .error").html(Resources.GIFTCERT_NO_BLANK).show();
		}
	});

	$(".gc-message textarea").on("keyup keydown", function() {
		var max = $(".gc-message span.max-char-limit").data("maxlimit");
		var value = $(this).val();
		var left = max - value.length;
		if (left < 0) {
			$(this).val( value.slice(0, left) );
			left = 0;
		}
		$(".gc-message span.count").text(left);
	});

	$("#GiftCertificateForm").on("click", "#AddToBasketButton", function(e) {
		e.preventDefault();

		var $form = $(this).closest("form");

		$form.validate();

		var $amt = $form.find(".amount-selection");
		var $pa = $(".purchase-amount");
		var $opa = $(".purchase-amount-other");

		if ($amt.find("li.selected").length == 0) {
			if ($opa.is(":visible") == false && $(".error.choose-amount").length == 0) {
				$("<div class='error choose-amount' role='alert'>"+Resources.VALIDATE_ERRORPREFIX+ " " +Resources.GIFT_CERT_CHOOSE_AMOUNT+"</div>").appendTo($pa);
			}
		}

		if ($form.valid()) {
			var _data = $form.serialize();

			$.getJSON($form.attr("action"), _data).done(function( data ) {
				if (data) {
					if (data.errors && data.errors.GeneralErrors && data.errors.GeneralErrors.length > 0) {
						// We only need to show a single general error at a time.
						$form.find(".error.general").html(data.errors.GeneralErrors[0]).css({margin: "0 0 20px 0"});
					}

					if (data.success) {
						// refresh page to update mini cart and clear the form.
						window.location = $form.data("redirect");
					}
				}
			});
		}
	});

};

const pageEntry = {
	init: function () {
		initializeDOM();
		initializeEvents();
	}
};

if (!window.appPages) {
	window.appPages = {};
}

window.appPages.giftcard = pageEntry;
